var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[(!_vm.policy)?_c('SelectPolicy',{on:{"select":_vm.updatePolicy}}):_c('EndorsementSelectedPolicy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }